export class Alerta {
    tipo: TipoAlerta;
    mensaje: string;
    cerrar: boolean;
}

export enum TipoAlerta {
    Success,
    Error,
    Info,
    Warning
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/components/alerta/alerta.ts